import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useAuthModal } from "../context/AuthModalContext";

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const { openLogin } = useAuthModal();
  const location = useLocation();

  useEffect(() => { if (!loading && !user) openLogin(); }, [loading, user, openLogin]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F8FC]">
        <Loader2 className="animate-spin text-emerald-600" size={28} />
      </div>
    );
  }
  if (!user) return <Navigate to="/" state={{ from: location }} replace />;
  return children;
};

export default RequireAuth;
